export default __webpack_public_path__ + "9fbec8fe50153d858a11074dcf058a8a.svg";